import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, FormGroup, Input, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"

class ProcessModal extends Component {
    _handleChangeNote = (e) => {
        const {value} = e.target
        const {onChangeNote} = this.props

        if (typeof onChangeNote === 'function') {
            onChangeNote(value)
        }
    }

    render() {
        const {barcodeNumber, isOpen, onOpen, onClose, onProcessRequest, loading, error, uploadStatus, content} = this.props

        return (
            <div className='ProcessModal'>
                <Modal isOpen={isOpen} toggle={onOpen}>
                    <ModalHeader toggle={onClose}>Duyệt generate label cho
                        order <strong>#{barcodeNumber}</strong></ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <label htmlFor="note">Nội dung:</label>
                            <Input type='textarea' defaultValue={content || ''} onChange={this._handleChangeNote}
                                   id='note'
                                   placeholder='Lý do đồng ý hoặc lý do từ chối'/>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter className='d-flex align-items-center justify-content-between'>
                        <Button color="danger" onClick={() => onProcessRequest('rejected')}>
                            {loading === 'rejected' && <i className='fa fa-spinner fa-spin mr-1'/>}
                            Từ chối
                        </Button>
                        {(error) && <div className='text-danger'>{error}</div>}
                        <Button color="primary" disabled={uploadStatus !== 'success'}
                                onClick={() => onProcessRequest('approved')}>
                            {loading === 'approved' && <i className='fa fa-spinner fa-spin mr-1'/>}
                            Đồng ý
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

ProcessModal.propTypes = {
    loading: PropTypes.any,
    error: PropTypes.string,
    content: PropTypes.string,
    barcodeNumber: PropTypes.number,
    isOpen: PropTypes.bool.isRequired,
    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
}

export default ProcessModal